import symbolName from "@/util/symbol-name.mjs";

export const GAME_SYMBOL_MARVEL_RIVALS: unique symbol =
  symbolName("marvelrivals");
